import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class AccountAuthGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    this.userService.restoreAuthStateFromStorage();

    if (this.userService.isAuthenticated()) {
      return true;
    }

    return this.router.createUrlTree(['/']);
  }
}
